import momentClass from 'moment';

export const moment = momentClass;
